import { DataGridUtil } from './../../kymw00/data-grid-util';
import { PlessViewUtilsSub } from './../../kymw00/pless-view-utils-sub.service';
import { KYMW0800OutputModel } from './vo/kymw0800-output.model';
import { GetResultListService } from './api-services/get-result-list.service';
import { DeleteWorkTableService } from './api-services/delete.work.table.service';
import { FileDownloadConfirmService } from './../../kymw02/file-download-confirm/file-download-confirm.service';
import { MakeResultListService } from './api-services/make.result.list.service';
import { Menu } from '@grapecity/wijmo.input';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, ViewContainerRef, HostListener } from '@angular/core';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0800Model } from './kymw0800.model';
import { KYMW0800InputModel } from './vo/kymw0800-input.model';
import { PlessDialogServiceSub } from './../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { RegistPlanNumModel } from './vo/regist-plan-num.model';
import { ResultListModel } from './vo/result-list.model';
import { WjFlexGridColumn } from '@grapecity/wijmo.angular2.grid';
import { RegistPlanNumService } from './api-services/regist-plan-num.service';
import { Point, EventArgs } from '@grapecity/wijmo';
import { NavigateURLUtilService } from '../../kymw02/navigate-url/navigate-url-util.service';
import { PdfFileCopyService } from './api-services/pdf-file-copy.service';
import { CellRange, CellType, FlexGrid } from '@grapecity/wijmo.grid';
import { PlanGoodsLockService } from '../../kymw00/api-services/plan-goods-lock.service';

/**
 * 実績履歴画面を管理するクラス
 *
 * @export KYMW0800Component
 * @class KYMW0800Component
 */
@Component({
  selector: 'app-kymw0800',
  templateUrl: 'kymw0800.component.html',
  styleUrls: ['kymw0800.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0800Component extends PlessViewHelperSub implements OnInit {

  // 表のタイトル
  public readonly HEAD_TEXT: string = <string>'実績額\n(千円)';
  public readonly HEAD_TEXT_I_01: string = <string>'企画回\n(い)';
  public readonly HEAD_TEXT_I_02: string = <string>'供給価\n(い)';
  public readonly HEAD_TEXT_I_03: string = <string>'単仕入価\n(い)';
  public readonly HEAD_TEXT_I_04: string = <string>'ページ\n(い)';
  public readonly HEAD_TEXT_I_05: string = <string>'枠数\n(い)';
  public readonly HEAD_TEXT_I_06: string = <string>'価格パターン\n(い)';
  public readonly HEAD_TEXT_I_07: string = <string>'登場区分\n(い)';
  public readonly HEAD_TEXT_I_08: string = <string>'計画数\n(い)';
  public readonly HEAD_TEXT_I_09: string = <string>'実績数\n(い)';
  public readonly HEAD_TEXT_I_10: string = <string>'実績額\n(い)';
  public readonly HEAD_TEXT_TO_01: string = <string>'企画回\n(と)';
  public readonly HEAD_TEXT_TO_02: string = <string>'供給価\n(と)';
  public readonly HEAD_TEXT_TO_03: string = <string>'単仕入価\n(と)';
  public readonly HEAD_TEXT_TO_04: string = <string>'ページ\n(と)';
  public readonly HEAD_TEXT_TO_05: string = <string>'枠数\n(と)';
  public readonly HEAD_TEXT_TO_06: string = <string>'価格パターン\n(と)';
  public readonly HEAD_TEXT_TO_07: string = <string>'登場区分\n(と)';
  public readonly HEAD_TEXT_TO_08: string = <string>'計画数\n(と)';
  public readonly HEAD_TEXT_TO_09: string = <string>'実績数\n(と)';
  public readonly HEAD_TEXT_TO_10: string = <string>'実績額\n(と)';
  public readonly HEAD_TEXT_GU_01: string = <string>'企画回\n(ぐ)';
  public readonly HEAD_TEXT_GU_02: string = <string>'供給価\n(ぐ)';
  public readonly HEAD_TEXT_GU_03: string = <string>'単仕入価\n(ぐ)';
  public readonly HEAD_TEXT_GU_04: string = <string>'ページ\n(ぐ)';
  public readonly HEAD_TEXT_GU_05: string = <string>'枠数\n(ぐ)';
  public readonly HEAD_TEXT_GU_06: string = <string>'価格パターン\n(ぐ)';
  public readonly HEAD_TEXT_GU_07: string = <string>'登場区分\n(ぐ)';
  public readonly HEAD_TEXT_GU_08: string = <string>'計画数\n(ぐ)';
  public readonly HEAD_TEXT_GU_09: string = <string>'実績数\n(ぐ)';
  public readonly HEAD_TEXT_GU_10: string = <string>'実績額\n(ぐ)';
  public readonly HEAD_TEXT_TI_01: string = <string>'企画回\n(ち)';
  public readonly HEAD_TEXT_TI_02: string = <string>'供給価\n(ち)';
  public readonly HEAD_TEXT_TI_03: string = <string>'単仕入価\n(ち)';
  public readonly HEAD_TEXT_TI_04: string = <string>'ページ\n(ち)';
  public readonly HEAD_TEXT_TI_05: string = <string>'枠数\n(ち)';
  public readonly HEAD_TEXT_TI_06: string = <string>'価格パターン\n(ち)';
  public readonly HEAD_TEXT_TI_07: string = <string>'登場区分\n(ち)';
  public readonly HEAD_TEXT_TI_08: string = <string>'計画数\n(ち)';
  public readonly HEAD_TEXT_TI_09: string = <string>'実績数\n(ち)';
  public readonly HEAD_TEXT_TI_10: string = <string>'実績額\n(ち)';
  public readonly HEAD_TEXT_SA_01: string = <string>'企画回\n(さ)';
  public readonly HEAD_TEXT_SA_02: string = <string>'供給価\n(さ)';
  public readonly HEAD_TEXT_SA_03: string = <string>'単仕入価\n(さ)';
  public readonly HEAD_TEXT_SA_04: string = <string>'ページ\n(さ)';
  public readonly HEAD_TEXT_SA_05: string = <string>'枠数\n(さ)';
  public readonly HEAD_TEXT_SA_06: string = <string>'価格パターン\n(さ)';
  public readonly HEAD_TEXT_SA_07: string = <string>'登場区分\n(さ)';
  public readonly HEAD_TEXT_SA_08: string = <string>'計画数\n(さ)';
  public readonly HEAD_TEXT_SA_09: string = <string>'実績数\n(さ)';
  public readonly HEAD_TEXT_SA_10: string = <string>'実績額\n(さ)';
  public readonly HEAD_TEXT_TOU_01: string = <string>'企画回\n(とう)';
  public readonly HEAD_TEXT_TOU_02: string = <string>'供給価\n(とう)';
  public readonly HEAD_TEXT_TOU_03: string = <string>'単仕入価\n(とう)';
  public readonly HEAD_TEXT_TOU_04: string = <string>'ページ\n(とう)';
  public readonly HEAD_TEXT_TOU_05: string = <string>'枠数\n(とう)';
  public readonly HEAD_TEXT_TOU_06: string = <string>'価格パターン\n(とう)';
  public readonly HEAD_TEXT_TOU_07: string = <string>'登場区分\n(とう)';
  public readonly HEAD_TEXT_TOU_08: string = <string>'計画数\n(とう)';
  public readonly HEAD_TEXT_TOU_09: string = <string>'実績数\n(とう)';
  public readonly HEAD_TEXT_TOU_10: string = <string>'実績額\n(とう)';
  public readonly HEAD_TEXT_NA_01: string = <string>'企画回\n(な)';
  public readonly HEAD_TEXT_NA_02: string = <string>'供給価\n(な)';
  public readonly HEAD_TEXT_NA_03: string = <string>'単仕入価\n(な)';
  public readonly HEAD_TEXT_NA_04: string = <string>'ページ\n(な)';
  public readonly HEAD_TEXT_NA_05: string = <string>'枠数\n(な)';
  public readonly HEAD_TEXT_NA_06: string = <string>'価格パターン\n(な)';
  public readonly HEAD_TEXT_NA_07: string = <string>'登場区分\n(な)';
  public readonly HEAD_TEXT_NA_08: string = <string>'計画数\n(な)';
  public readonly HEAD_TEXT_NA_09: string = <string>'実績数\n(な)';
  public readonly HEAD_TEXT_NA_10: string = <string>'実績額\n(な)';
  public readonly HEAD_TEXT_NI_01: string = <string>'企画回\n(に)';
  public readonly HEAD_TEXT_NI_02: string = <string>'供給価\n(に)';
  public readonly HEAD_TEXT_NI_03: string = <string>'単仕入価\n(に)';
  public readonly HEAD_TEXT_NI_04: string = <string>'ページ\n(に)';
  public readonly HEAD_TEXT_NI_05: string = <string>'枠数\n(に)';
  public readonly HEAD_TEXT_NI_06: string = <string>'価格パターン\n(に)';
  public readonly HEAD_TEXT_NI_07: string = <string>'登場区分\n(に)';
  public readonly HEAD_TEXT_NI_08: string = <string>'計画数\n(に)';
  public readonly HEAD_TEXT_NI_09: string = <string>'実績数\n(に)';
  public readonly HEAD_TEXT_NI_10: string = <string>'実績額\n(に)';

  public readonly HEAD_TEXT_I2_01: string = <string>'配達企画回\n(い)';
  public readonly HEAD_TEXT_I2_02: string = <string>'供給価格\n(い)';
  public readonly HEAD_TEXT_I2_03: string = <string>'単品仕入価格\n(い)';
  public readonly HEAD_TEXT_I2_05: string = <string>'掲載枠数\n(い)';
  public readonly HEAD_TEXT_I2_10: string = <string>'実績額(千円)\n(い)';

  public readonly HEAD_TEXT_TO2_01: string = <string>'配達企画回\n(と)';
  public readonly HEAD_TEXT_TO2_02: string = <string>'供給価格\n(と)';
  public readonly HEAD_TEXT_TO2_03: string = <string>'単品仕入価格\n(と)';
  public readonly HEAD_TEXT_TO2_05: string = <string>'掲載枠数\n(と)';
  public readonly HEAD_TEXT_TO2_10: string = <string>'実績額(千円)\n(と)';

  public readonly HEAD_TEXT_GU2_01: string = <string>'配達企画回\n(ぐ)';
  public readonly HEAD_TEXT_GU2_02: string = <string>'供給価格\n(ぐ)';
  public readonly HEAD_TEXT_GU2_03: string = <string>'単品仕入価格\n(ぐ)';
  public readonly HEAD_TEXT_GU2_05: string = <string>'掲載枠数\n(ぐ)';
  public readonly HEAD_TEXT_GU2_10: string = <string>'実績額(千円)\n(ぐ)';

  public readonly HEAD_TEXT_TI2_01: string = <string>'配達企画回\n(ち)';
  public readonly HEAD_TEXT_TI2_02: string = <string>'供給価格\n(ち)';
  public readonly HEAD_TEXT_TI2_03: string = <string>'単品仕入価格\n(ち)';
  public readonly HEAD_TEXT_TI2_05: string = <string>'掲載枠数\n(ち)';
  public readonly HEAD_TEXT_TI2_10: string = <string>'実績額(千円)\n(ち)';

  public readonly HEAD_TEXT_SA2_01: string = <string>'配達企画回\n(さ)';
  public readonly HEAD_TEXT_SA2_02: string = <string>'供給価格\n(さ)';
  public readonly HEAD_TEXT_SA2_03: string = <string>'単品仕入価格\n(さ)';
  public readonly HEAD_TEXT_SA2_05: string = <string>'掲載枠数\n(さ)';
  public readonly HEAD_TEXT_SA2_10: string = <string>'実績額(千円)\n(さ)';

  public readonly HEAD_TEXT_TOU2_01: string = <string>'配達企画回\n(とう)';
  public readonly HEAD_TEXT_TOU2_02: string = <string>'供給価格\n(とう)';
  public readonly HEAD_TEXT_TOU2_03: string = <string>'単品仕入価格\n(とう)';
  public readonly HEAD_TEXT_TOU2_05: string = <string>'掲載枠数\n(とう)';
  public readonly HEAD_TEXT_TOU2_10: string = <string>'実績額(千円)\n(とう)';

  public readonly HEAD_TEXT_NA2_01: string = <string>'配達企画回\n(な)';
  public readonly HEAD_TEXT_NA2_02: string = <string>'供給価格\n(な)';
  public readonly HEAD_TEXT_NA2_03: string = <string>'単品仕入価格\n(な)';
  public readonly HEAD_TEXT_NA2_05: string = <string>'掲載枠数\n(な)';
  public readonly HEAD_TEXT_NA2_10: string = <string>'実績額(千円)\n(な)';

  public readonly HEAD_TEXT_NI2_01: string = <string>'配達企画回\n(に)';
  public readonly HEAD_TEXT_NI2_02: string = <string>'供給価格\n(に)';
  public readonly HEAD_TEXT_NI2_03: string = <string>'単品仕入価格\n(に)';
  public readonly HEAD_TEXT_NI2_05: string = <string>'掲載枠数\n(に)';
  public readonly HEAD_TEXT_NI2_10: string = <string>'実績額(千円)\n(に)';


  // グリッドスタブ
  @ViewChild('cmb_PCodeList', { static: true }) cmb_PCodeList: ElementRef;
  @ViewChild('dtg_ResultList', { static: true }) dtg_ResultList: FlexGrid;
  @ViewChild('btn_Back', { static: true }) btn_Back: ElementRef;
  @ViewChild('btn_Next', { static: true }) btn_Next: ElementRef;
  @ViewChild('dtg_OrderCode', { static: true }) dtg_OrderCode: WjFlexGridColumn;
  @ViewChild('dtg_DelivCatlogId', { static: true }) dtg_DelivCatlogId: WjFlexGridColumn;
  @ViewChild('dtg_MediumName', { static: true }) dtg_MediumName: WjFlexGridColumn;
  @ViewChild('dtg_Pcode', { static: true }) dtg_Pcode: WjFlexGridColumn;
  @ViewChild('dtg_HandlingCoop1', { static: true }) dtg_HandlingCoop1: WjFlexGridColumn;
  @ViewChild('dtg_HandlingCoop2', { static: true }) dtg_HandlingCoop2: WjFlexGridColumn;
  @ViewChild('dtg_HandlingCoop3', { static: true }) dtg_HandlingCoop3: WjFlexGridColumn;
  @ViewChild('dtg_HandlingCoop4', { static: true }) dtg_HandlingCoop4: WjFlexGridColumn;
  @ViewChild('dtg_HandlingCoop5', { static: true }) dtg_HandlingCoop5: WjFlexGridColumn;
  @ViewChild('dtg_HandlingCoop6', { static: true }) dtg_HandlingCoop6: WjFlexGridColumn;
  @ViewChild('dtg_HandlingCoop7', { static: true }) dtg_HandlingCoop7: WjFlexGridColumn;
  @ViewChild('dtg_HandlingCoop8', { static: true }) dtg_HandlingCoop8: WjFlexGridColumn;
  @ViewChild('dtg_PlanNumTotal', { static: true }) dtg_PlanNumTotal: WjFlexGridColumn;
  @ViewChild('dtg_ResultNumTotal', { static: true }) dtg_ResultNumTotal: WjFlexGridColumn;
  @ViewChild('dtg_ResultPriceTotal', { static: true }) dtg_ResultPriceTotal: WjFlexGridColumn;
  @ViewChild('dtg_ResultPiTotal', { static: true }) dtg_ResultPiTotal: WjFlexGridColumn;
  @ViewChild('dtg_Dummy', { static: true }) dtg_Dummy: WjFlexGridColumn;
  @ViewChild('dtg_DetailI0', { static: true }) dtg_DetailI0: WjFlexGridColumn;
  @ViewChild('dtg_DetailI1', { static: true }) dtg_DetailI1: WjFlexGridColumn;
  @ViewChild('dtg_DetailI2', { static: true }) dtg_DetailI2: WjFlexGridColumn;
  @ViewChild('dtg_DetailI3', { static: true }) dtg_DetailI3: WjFlexGridColumn;
  @ViewChild('dtg_DetailI4', { static: true }) dtg_DetailI4: WjFlexGridColumn;
  @ViewChild('dtg_DetailI5', { static: true }) dtg_DetailI5: WjFlexGridColumn;
  @ViewChild('dtg_DetailI6', { static: true }) dtg_DetailI6: WjFlexGridColumn;
  @ViewChild('dtg_DetailI7', { static: true }) dtg_DetailI7: WjFlexGridColumn;
  @ViewChild('dtg_DetailI8', { static: true }) dtg_DetailI8: WjFlexGridColumn;
  @ViewChild('dtg_DetailI9', { static: true }) dtg_DetailI9: WjFlexGridColumn;
  @ViewChild('dtg_DetailT0', { static: true }) dtg_DetailT0: WjFlexGridColumn;
  @ViewChild('dtg_DetailT1', { static: true }) dtg_DetailT1: WjFlexGridColumn;
  @ViewChild('dtg_DetailT2', { static: true }) dtg_DetailT2: WjFlexGridColumn;
  @ViewChild('dtg_DetailT3', { static: true }) dtg_DetailT3: WjFlexGridColumn;
  @ViewChild('dtg_DetailT4', { static: true }) dtg_DetailT4: WjFlexGridColumn;
  @ViewChild('dtg_DetailT5', { static: true }) dtg_DetailT5: WjFlexGridColumn;
  @ViewChild('dtg_DetailT6', { static: true }) dtg_DetailT6: WjFlexGridColumn;
  @ViewChild('dtg_DetailT7', { static: true }) dtg_DetailT7: WjFlexGridColumn;
  @ViewChild('dtg_DetailT8', { static: true }) dtg_DetailT8: WjFlexGridColumn;
  @ViewChild('dtg_DetailT9', { static: true }) dtg_DetailT9: WjFlexGridColumn;
  @ViewChild('dtg_DetailG0', { static: true }) dtg_DetailG0: WjFlexGridColumn;
  @ViewChild('dtg_DetailG1', { static: true }) dtg_DetailG1: WjFlexGridColumn;
  @ViewChild('dtg_DetailG2', { static: true }) dtg_DetailG2: WjFlexGridColumn;
  @ViewChild('dtg_DetailG3', { static: true }) dtg_DetailG3: WjFlexGridColumn;
  @ViewChild('dtg_DetailG4', { static: true }) dtg_DetailG4: WjFlexGridColumn;
  @ViewChild('dtg_DetailG5', { static: true }) dtg_DetailG5: WjFlexGridColumn;
  @ViewChild('dtg_DetailG6', { static: true }) dtg_DetailG6: WjFlexGridColumn;
  @ViewChild('dtg_DetailG7', { static: true }) dtg_DetailG7: WjFlexGridColumn;
  @ViewChild('dtg_DetailG8', { static: true }) dtg_DetailG8: WjFlexGridColumn;
  @ViewChild('dtg_DetailG9', { static: true }) dtg_DetailG9: WjFlexGridColumn;
  @ViewChild('dtg_DetailC0', { static: true }) dtg_DetailC0: WjFlexGridColumn;
  @ViewChild('dtg_DetailC1', { static: true }) dtg_DetailC1: WjFlexGridColumn;
  @ViewChild('dtg_DetailC2', { static: true }) dtg_DetailC2: WjFlexGridColumn;
  @ViewChild('dtg_DetailC3', { static: true }) dtg_DetailC3: WjFlexGridColumn;
  @ViewChild('dtg_DetailC4', { static: true }) dtg_DetailC4: WjFlexGridColumn;
  @ViewChild('dtg_DetailC5', { static: true }) dtg_DetailC5: WjFlexGridColumn;
  @ViewChild('dtg_DetailC6', { static: true }) dtg_DetailC6: WjFlexGridColumn;
  @ViewChild('dtg_DetailC7', { static: true }) dtg_DetailC7: WjFlexGridColumn;
  @ViewChild('dtg_DetailC8', { static: true }) dtg_DetailC8: WjFlexGridColumn;
  @ViewChild('dtg_DetailC9', { static: true }) dtg_DetailC9: WjFlexGridColumn;
  @ViewChild('dtg_DetailS0', { static: true }) dtg_DetailS0: WjFlexGridColumn;
  @ViewChild('dtg_DetailS1', { static: true }) dtg_DetailS1: WjFlexGridColumn;
  @ViewChild('dtg_DetailS2', { static: true }) dtg_DetailS2: WjFlexGridColumn;
  @ViewChild('dtg_DetailS3', { static: true }) dtg_DetailS3: WjFlexGridColumn;
  @ViewChild('dtg_DetailS4', { static: true }) dtg_DetailS4: WjFlexGridColumn;
  @ViewChild('dtg_DetailS5', { static: true }) dtg_DetailS5: WjFlexGridColumn;
  @ViewChild('dtg_DetailS6', { static: true }) dtg_DetailS6: WjFlexGridColumn;
  @ViewChild('dtg_DetailS7', { static: true }) dtg_DetailS7: WjFlexGridColumn;
  @ViewChild('dtg_DetailS8', { static: true }) dtg_DetailS8: WjFlexGridColumn;
  @ViewChild('dtg_DetailS9', { static: true }) dtg_DetailS9: WjFlexGridColumn;
  @ViewChild('dtg_DetailTO0', { static: true }) dtg_DetailTO0: WjFlexGridColumn;
  @ViewChild('dtg_DetailTO1', { static: true }) dtg_DetailTO1: WjFlexGridColumn;
  @ViewChild('dtg_DetailTO2', { static: true }) dtg_DetailTO2: WjFlexGridColumn;
  @ViewChild('dtg_DetailTO3', { static: true }) dtg_DetailTO3: WjFlexGridColumn;
  @ViewChild('dtg_DetailTO4', { static: true }) dtg_DetailTO4: WjFlexGridColumn;
  @ViewChild('dtg_DetailTO5', { static: true }) dtg_DetailTO5: WjFlexGridColumn;
  @ViewChild('dtg_DetailTO6', { static: true }) dtg_DetailTO6: WjFlexGridColumn;
  @ViewChild('dtg_DetailTO7', { static: true }) dtg_DetailTO7: WjFlexGridColumn;
  @ViewChild('dtg_DetailTO8', { static: true }) dtg_DetailTO8: WjFlexGridColumn;
  @ViewChild('dtg_DetailTO9', { static: true }) dtg_DetailTO9: WjFlexGridColumn;
  @ViewChild('dtg_DetailNA0', { static: true }) dtg_DetailNA0: WjFlexGridColumn;
  @ViewChild('dtg_DetailNA1', { static: true }) dtg_DetailNA1: WjFlexGridColumn;
  @ViewChild('dtg_DetailNA2', { static: true }) dtg_DetailNA2: WjFlexGridColumn;
  @ViewChild('dtg_DetailNA3', { static: true }) dtg_DetailNA3: WjFlexGridColumn;
  @ViewChild('dtg_DetailNA4', { static: true }) dtg_DetailNA4: WjFlexGridColumn;
  @ViewChild('dtg_DetailNA5', { static: true }) dtg_DetailNA5: WjFlexGridColumn;
  @ViewChild('dtg_DetailNA6', { static: true }) dtg_DetailNA6: WjFlexGridColumn;
  @ViewChild('dtg_DetailNA7', { static: true }) dtg_DetailNA7: WjFlexGridColumn;
  @ViewChild('dtg_DetailNA8', { static: true }) dtg_DetailNA8: WjFlexGridColumn;
  @ViewChild('dtg_DetailNA9', { static: true }) dtg_DetailNA9: WjFlexGridColumn;
  @ViewChild('dtg_DetailN0', { static: true }) dtg_DetailN0: WjFlexGridColumn;
  @ViewChild('dtg_DetailN1', { static: true }) dtg_DetailN1: WjFlexGridColumn;
  @ViewChild('dtg_DetailN2', { static: true }) dtg_DetailN2: WjFlexGridColumn;
  @ViewChild('dtg_DetailN3', { static: true }) dtg_DetailN3: WjFlexGridColumn;
  @ViewChild('dtg_DetailN4', { static: true }) dtg_DetailN4: WjFlexGridColumn;
  @ViewChild('dtg_DetailN5', { static: true }) dtg_DetailN5: WjFlexGridColumn;
  @ViewChild('dtg_DetailN6', { static: true }) dtg_DetailN6: WjFlexGridColumn;
  @ViewChild('dtg_DetailN7', { static: true }) dtg_DetailN7: WjFlexGridColumn;
  @ViewChild('dtg_DetailN8', { static: true }) dtg_DetailN8: WjFlexGridColumn;
  @ViewChild('dtg_DetailN9', { static: true }) dtg_DetailN9: WjFlexGridColumn;
  @ViewChild('btn_Out', { static: true }) btn_Out: ElementRef;


  kymw0800Model: KYMW0800Model = new KYMW0800Model();

  setKYMW0800Parameter: Function;

  /** 受渡情報取得VO */
  public inputVo: KYMW0800InputModel = null;
  /** 実績履歴取得VO */
  public resultListVo: ResultListModel = null;
  /** 計画数設定VO */
  public registVO: RegistPlanNumModel = null;
  /** DataGridの列名とテーブル物理名を紐付ける連想配列 */
  public tableName: any;

  /** コンテキストメニュー */
  public contextMenu: Menu;

  // 初期フォーカス設定フラグ
  private initFocusFlag = Boolean(true);

  /**
   * ウィンドウ内のクリック・右クリック時にイベントを追加
   *
   * @param {*} event
   * @memberof KYMW0800Component
   */
  @HostListener('click', ['$event'])
  @HostListener('contextmenu', ['$event'])
  private onClickOut(event: Event): void {
    if (this.contextMenu != null) {
      if (this.contextMenu.isDroppedDown && !this.contextMenu.containsFocus()) {
        // コンテキストメニューが表示状態でかつフォーカスが無い場合、コンテキストメニューを非表示とする
        this.contextMenu.hide();
      }
    }
  }

  /**
   *Creates an instance of KYMW0800Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0800Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    public viewContainerRef: ViewContainerRef,
    private getResultListService: GetResultListService,
    private makeResultListService: MakeResultListService,
    private deleteWorkTableService: DeleteWorkTableService,
    public fileDownloadConfirmService: FileDownloadConfirmService,
    private registPlanNumService: RegistPlanNumService,
    private pdfFileCopyService: PdfFileCopyService,
    public navigateURLUtilService: NavigateURLUtilService,
    private planGoodsLockServiceSub: PlanGoodsLockService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0800Component
   */
  public ngOnInit(): void {
    this.kymw0800Model.kymw0800Component = this;
    this.tableName = new Object();
    this.tableName['OrderCode'] = 'orderCode';      // 受注コード
    this.tableName['DelivCatalogId'] = 'delivCatalogId'; // 配達企画回
    this.tableName['MediumName'] = 'mediumName';     // 配達企画回
    this.tableName['PCode'] = 'pCode';          // Ｐコード
    this.componentName = 'KYMW0800';
    this.planGoodsLockService = this.planGoodsLockServiceSub;

    // グリッドの高さ指定
    this.dtg_ResultList.columnHeaders.rows[0].height = 52;

    // コンテキストメニュー設定
    this.setContextMenu();

    // 詳細表示チェックボックスをチェックする
    this.kymw0800Model.resultDetail = true;
    // 会員生協別情報を表示
    this.setResultDetailTrue();

    // Ｐコードコンボボックスを設定
    const pCodeList: Array<any> = this.inputVo.pCodeList;

    // Pコードリストチェック処理
    if (PlessViewUtilsSub.isEmptyArray(pCodeList)) {
      // Manageへ情報を保持
      this.kymw0800Model.pCodeList = new Array<any>();
      this.kymw0800Model.pCode = '';
      this.kymw0800Model.resultList = new Array<any>();
      this.kymw0800Model.totalNum = 0;
      this.kymw0800Model.startDispNum = 0;
      this.kymw0800Model.endDispNum = 0;

      // 選択したPコード情報を表示
      this.kymw0800Model.guideGoodsName = '';
      this.kymw0800Model.guideStandardName = '';

      // 出力ボタン制御(使用不可)
      this.updateOutputBtnEnableMode(false);

      // 前へ/次へボタンの活性制御(使用不可)
      this.setEnabledPrevNext();

      return;
    }

    // Manageへ情報を保持
    this.kymw0800Model.pCodeList = pCodeList;
    this.kymw0800Model.pCode = pCodeList[0].PCode;

    // 選択したPコード情報を表示
    this.kymw0800Model.guideGoodsName = this.kymw0800Model.pCodeList[0].GuideGoodsName;
    this.kymw0800Model.guideStandardName = this.kymw0800Model.pCodeList[0].GuideStandardName;

    // コマ割画面にての選択コマ変更時、ソート表示を初期化
    this.resetGridHeaderText();

    // ResultListVOの初期値を設定
    this.setInitResultListVO();

    // VOに必要な情報を設定（Ｐコード）
    this.resultListVo.pCode = pCodeList[0].PCode;

    // ワークテーブルの作成フラグ初期化
    this.updateMakedWKTFlag(false);

    // 出力情報の取得要求を行う
    this.getResultList();

    // グリッドの初期選択行はなしとする
    this.dtg_ResultList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_ResultList.select(-1, -1);
      if (this.initFocusFlag) {
        this.cmb_PCodeList.nativeElement.focus();
        this.initFocusFlag = false;
      }
    });
  }

  public setInterfaceParam(param: any) {
    this.inputVo = <KYMW0800InputModel>param;
  }

  /**
   * @copy jp.co.toppan.pless.common.view.PlessViewHelper#setInputVO()
   */
  public setInputVO(inputVO: any): void {
    // コマ割からの再表示要求時
    // 受渡情報の設定
    this.inputVo = <KYMW0800InputModel>inputVO;
    // 初期処理を呼び出す
    this.ngOnInit();
  }

  /**
 * データグリッドでコンテキストメニューが呼び出されたときの処理
 * @param event コンテキストメニューイベント
 *
 */
  public eventDtgResultListContextMenu_MENUSELECTHandler(): void {
    // データグリッド上が選択状態であるか
    if (this.dtg_ResultList.selection.row > -1) {
      // 保持しているコンテキストメニュー分ループする
      this.contextMenu.itemsSource.forEach(item => {
        // 実績額(千円)がnullのデータ(子データ)を選択した場合、「計画数自動セット」を表示しない
        if (item.caption === '計画数自動セット') {
          let enabledFlag = item.enabled;
          if (PlessViewUtilsSub.isEmpty(this.dtg_ResultList.selectedItems[0].ResultPriceTotal)) {
            enabledFlag = false;
          }
          // コンテキストメニュー活性・非活性制御
          item.enabled = this.setContextMenuEnabled(item, enabledFlag);
        }
      });
    }
  }

  /**
   * グリッドページセルクリックイベント処理
   */
  public eventPdfLinkButtonClickHandler(fileName: string): void {
    // PDFファイルコピーイベントを発生
    this.pdfFileCopyService.execute(this.kymw0800Model, fileName);
  }

  /**
   * 画像一覧データグリッド ヘッダクリックイベント処理
   */
  public eventResultList_HeaderHandler(e: MouseEvent, grid: FlexGrid): void {
    // 後続のデフォルトイベントをキャンセル
    event.preventDefault();

    // ソート可能かの判定
    if (!DataGridUtil.isSortable(e, this.dtg_ResultList)) {
      return;
    }

    // クリックされたデータグリッドの列から、DBの物理項目を取得
    this.resultListVo.sortItem = this.tableName[this.dtg_ResultList.columns[grid.hitTest(e).col].binding];
    // 取得できなかったら何もしない
    if (!this.resultListVo.sortItem) {
      return;
    }

    // データグリッドのヘッダテキストを描画し、ASCとDESCをVOに設定
    this.resultListVo.sortOrder = DataGridUtil.switchHeaderText(e, grid);

    // ページカウンタの初期化
    this.resultListVo.page = 1;

    // サーバにデータ取得を要求(Cairngormイベント発行)
    this.getResultList();
  }

  /**
   * 前へボタン_押下時のイベントリスナ
   * @param e イベント
   */
  public eventBack_ClickHandler(e: Event): void {
    // Pコードチェック
    if (this.registVO != null && PlessViewUtilsSub.isEmpty(this.registVO.pCode)) {
      return;
    }

    // 現在のページ番号+1を設定し、リストを取得
    let pageNo: number = this.resultListVo.page;
    if (pageNo < 1) {
      pageNo = 1;
    } else {
      pageNo = pageNo - 1;
    }
    this.resultListVo.page = pageNo;

    // 実績履歴取得の取得要求
    this.getResultList();
  }

  /**
   * 次へボタン_押下時のイベントリスナ
   * @param e イベント
   */
  public eventNext_ClickHandler(e: Event): void {
    // Pコードチェック
    if (this.registVO != null && PlessViewUtilsSub.isEmpty(this.registVO.pCode)) {
      return;
    }

    // 現在のページ番号+1を設定し、リストを取得
    let pageNo: number = this.resultListVo.page;
    if (pageNo < 1) {
      pageNo = 1;
    } else {
      pageNo = pageNo + 1;
    }
    this.resultListVo.page = pageNo;

    // 実績履歴取得の取得要求
    this.getResultList();
  }

  /**
   * 出力ボタン_押下時のイベントリスナ
   * @param e イベント
   */
  public eventOut_ClickHandler(e: Event): void {

    // サーバへの受渡情報を設定
    const vo = {
      pCode: this.kymw0800Model.pCode,
      sessionId: this.resultListVo.sessionId,
      detailFlg: ''
    };

    // 詳細表示状態をチェックし、Excel表示の設定フラグを判定する
    if (this.kymw0800Model.resultDetail) {

      // 詳細表示状態をチェック
      vo.detailFlg = '1';

    } else {

      // 詳細表示状態を非チェック
      vo.detailFlg = '0';
    }

    // 出力情報の取得要求を行う
    // 要求先：/KYMW08/makeResultList.xml
    this.makeResultListService.execute(this.kymw0800Model, vo, (data: any) => {
      // 対象データ無しの場合、エラーメッセージを表示
      if (data.FileName == null) {
        this.dialogService.openAlertGetMessage('E0100');

      } else {
        // ファイル名の設定
        const fileName = '実績履歴_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.xls';

        this.fileDownloadConfirmService.show(data.FileName, fileName);
      }
    });

  }

  /**
   * 閉じるボタン_押下時のイベントリスナ
   * @param e イベント
   */
  public eventClose_ClickHandler(e: Event): void {
    // 実績履歴WKテーブル削除
    // VOがnullの場合は空コマ等から起動し、データを一度も取得していない場合なので削除不要
    if (!(this.resultListVo === null)) {
      this.deleteWorkTableService.execute(this.resultListVo);
    }

    super.onClickClose();
  }

  /**
   * 詳細表示チェックボックス_チェック時のイベントリスナ
   * @param e イベント
   */
  public eventResultDetail_CheckHandler(e: Event): void {
    // 詳細表示にチェックがある場合
    if (this.kymw0800Model.resultDetail) {

      // 会員生協別情報を表示
      this.setResultDetailTrue();

    } else {

      // 会員生協別情報を非表示
      this.setResultDetailFalse();
    }
  }

  /**
   * Ｐコードコンボボックス_変更時のイベントリスナ
   * @param e イベント
   */
  public eventPCodeList_ChangedHandler(e: Event): void {

    // ResultListVOを初期化し、初期情報を設定
    this.setInitResultListVO();

    // ResultListVOに情報を設定（Ｐコード）
    this.resultListVo.pCode = this.kymw0800Model.pCode;

    // 選択したPコード情報を表示
    const idx: number = this.cmb_PCodeList.nativeElement.selectedIndex;
    this.kymw0800Model.guideGoodsName = this.kymw0800Model.pCodeList[idx].GuideGoodsName;
    this.kymw0800Model.guideStandardName = this.kymw0800Model.pCodeList[idx].GuideStandardName;

    // 出力情報の取得要求を行う
    this.getResultList();
  }

  /**
   * 右クリックメニューが表示されたときに呼び出されるメソッド
   * 主に右クリックされた行の選択と、メニュー項目の表示設定を行う
   *
   * @param event:コンテキストイベント
   */
  public eventContextMenu_Handler(): void {
    // コンテキストメニューが「削除」の場合、商品の判定を行う
    this.contextMenu.itemsSource.forEach(item => {
      let enabledFlag: boolean = item.enabled;
      // 遷移元画面が「商品企画マスタ」で、DataGridのItemが選択されている場合
      if (this.inputVo.funcID === 'KYMW1300' && this.dtg_ResultList.selection.row >= 0) {
        // コンテキストメニューの情報を活性化
        enabledFlag = true;

        // 遷移元画面が「商品企画マスタ」以外で、DataGridのItemが選択されている場合
      } else {

        // コンテキストメニューの情報を非活性化
        enabledFlag = false;
      }
      // コンテキストメニュー活性・非活性制御
      item.enabled = this.setContextMenuEnabled(item, enabledFlag);
    });
  }

  /**
   * コンテキスト「計画数自動セット」選択イベント処理
   *  @param e
   */
  public eventRegistPlanNum_CLICKHandler(): void {
    // 生協情報、選択行情報を設定
    this.setCoopInfo();
    this.registVO.orderCode = this.inputVo.orderCode; // 受注コード
    this.registVO.mediumType = this.inputVo.mediumType;	// 媒体区分
    this.registVO.pCode = this.kymw0800Model.pCode;     // Ｐコード

    // 排他チェック
    const successParam = {
      registVO: this.registVO,
      kymw0800Model: this.kymw0800Model,
    };
    this.LockUtilForPlanGoods('CHECK', this.registVO.orderCode, this.registVO.mediumType,
      this.registVO.pCode,
      () => {
  this.lockOk_registPlanNum(successParam);
}, null, this.lockErr_registPlanNum, null, false);
  }

  /**
   * 「前へ」「次へ」の活性、非活性設定を行う
   */
  public setListBtn(): void {
    // 「前へ」の活性判定を行う
    this.kymw0800Model.prevPageDisabled =
      !(Number(this.kymw0800Model.startDispNum) > 1);

    // 「次へ」の活性判定を行う
    this.kymw0800Model.nextPageDisabled =
      !(Number(this.kymw0800Model.endDispNum)
        < Number(this.kymw0800Model.totalNum));
  }

  /**
   * 実績履歴取得の取得要求を行う
   */
  public getResultList(): void {
    // 出力情報の取得要求を行う
    // 要求先：/KYMW08/this.getResultList.xml
    this.getResultListService.execute(this.kymw0800Model, this.resultListVo);
  }

  /**
   * ResultListVOの初期設定を行う
   */
  public setInitResultListVO(): void {
    this.resultListVo = new ResultListModel();

    // 初期表示は受注コードの昇順で設定
    this.resultListVo.formId = 'KYNW0800';
    this.resultListVo.page = 1;
    this.resultListVo.sortItem = '';
    this.resultListVo.sortOrder = '';
  }

  public resetGridHeaderText(): void {
    this.dtg_OrderCode.header = '受注コード';
    this.dtg_DelivCatlogId.header = '配達企画回';
    this.dtg_MediumName.header = '媒体';
    this.dtg_Pcode.header = 'Ｐコード';
  }

  /**
   * 呼び出し元の画面に返却
   */
  public setOutputInfo(): void {
    const outputVO: KYMW0800OutputModel = new KYMW0800OutputModel();

    // 呼び出し元の画面に返却する
    this.setKYMW0800Parameter(outputVO);
  }

  /**
   * 選択行情報と、生協情報を設定
   */
  public setCoopInfo(): void {
    // VO設定
    this.registVO = new RegistPlanNumModel();

    // 生協コードを設定
    this.registVO.coopCode1 = this.kymw00Model.COOP_CODE_IB;	// いばらき
    this.registVO.coopCode2 = this.kymw00Model.COOP_CODE_TO;	// とちぎ
    this.registVO.coopCode3 = this.kymw00Model.COOP_CODE_GU;	// ぐんま
    this.registVO.coopCode4 = this.kymw00Model.COOP_CODE_TI;	// ちば
    this.registVO.coopCode5 = this.kymw00Model.COOP_CODE_SA;	// さいたま
    this.registVO.coopCode6 = this.kymw00Model.COOP_CODE_TK;	// とうきょう
    this.registVO.coopCode7 = this.kymw00Model.COOP_CODE_NA;	// ながの
    this.registVO.coopCode8 = this.kymw00Model.COOP_CODE_NI;	// にいがた

    // 点数PIの取得
    this.registVO.numPi1 = this.dtg_ResultList.selectedItems[0].NumPi1;	// いばらき
    this.registVO.numPi2 = this.dtg_ResultList.selectedItems[0].NumPi2;	// とちぎ
    this.registVO.numPi3 = this.dtg_ResultList.selectedItems[0].NumPi3;	// ぐんま
    this.registVO.numPi4 = this.dtg_ResultList.selectedItems[0].NumPi4;	// ちば
    this.registVO.numPi5 = this.dtg_ResultList.selectedItems[0].NumPi5;	// さいたま
    this.registVO.numPi6 = this.dtg_ResultList.selectedItems[0].NumPi6;	// とうきょう
    this.registVO.numPi7 = this.dtg_ResultList.selectedItems[0].NumPi7;	// ながの
    this.registVO.numPi8 = this.dtg_ResultList.selectedItems[0].NumPi8;	// にいがた;
  }

  /**
   * 会員生協別情報を表示
   */
  public setResultDetailTrue(): void {

    this.dtg_ResultList.scrollPosition = new Point(0, 0);

    this.dtg_OrderCode.visible = true;
    this.dtg_DelivCatlogId.visible = true;
    this.dtg_MediumName.visible = true;
    this.dtg_Pcode.visible = true;
    this.dtg_HandlingCoop1.visible = true;
    this.dtg_HandlingCoop2.visible = true;
    this.dtg_HandlingCoop3.visible = true;
    this.dtg_HandlingCoop4.visible = true;
    this.dtg_HandlingCoop5.visible = true;
    this.dtg_HandlingCoop6.visible = true;
    this.dtg_HandlingCoop7.visible = true;
    this.dtg_HandlingCoop8.visible = true;
    this.dtg_ResultPriceTotal.visible = true;
    this.dtg_ResultNumTotal.visible = true;
    this.dtg_ResultPiTotal.visible = true;
    this.dtg_PlanNumTotal.visible = true;

    this.dtg_Dummy.visible = false;			// ダミー列

    this.dtg_DetailI0.visible = true;
    this.dtg_DetailI1.visible = true;
    this.dtg_DetailI2.visible = true;
    this.dtg_DetailI3.visible = true;
    this.dtg_DetailI4.visible = true;
    this.dtg_DetailI5.visible = true;
    this.dtg_DetailI6.visible = true;
    this.dtg_DetailI7.visible = true;
    this.dtg_DetailI8.visible = true;
    this.dtg_DetailI9.visible = true;
    this.dtg_DetailT0.visible = true;
    this.dtg_DetailT1.visible = true;
    this.dtg_DetailT2.visible = true;
    this.dtg_DetailT3.visible = true;
    this.dtg_DetailT4.visible = true;
    this.dtg_DetailT5.visible = true;
    this.dtg_DetailT6.visible = true;
    this.dtg_DetailT7.visible = true;
    this.dtg_DetailT8.visible = true;
    this.dtg_DetailT9.visible = true;
    this.dtg_DetailG0.visible = true;
    this.dtg_DetailG1.visible = true;
    this.dtg_DetailG2.visible = true;
    this.dtg_DetailG3.visible = true;
    this.dtg_DetailG4.visible = true;
    this.dtg_DetailG5.visible = true;
    this.dtg_DetailG6.visible = true;
    this.dtg_DetailG7.visible = true;
    this.dtg_DetailG8.visible = true;
    this.dtg_DetailG9.visible = true;
    this.dtg_DetailC0.visible = true;
    this.dtg_DetailC1.visible = true;
    this.dtg_DetailC2.visible = true;
    this.dtg_DetailC3.visible = true;
    this.dtg_DetailC4.visible = true;
    this.dtg_DetailC5.visible = true;
    this.dtg_DetailC6.visible = true;
    this.dtg_DetailC7.visible = true;
    this.dtg_DetailC8.visible = true;
    this.dtg_DetailC9.visible = true;
    this.dtg_DetailS0.visible = true;
    this.dtg_DetailS1.visible = true;
    this.dtg_DetailS2.visible = true;
    this.dtg_DetailS3.visible = true;
    this.dtg_DetailS4.visible = true;
    this.dtg_DetailS5.visible = true;
    this.dtg_DetailS6.visible = true;
    this.dtg_DetailS7.visible = true;
    this.dtg_DetailS8.visible = true;
    this.dtg_DetailS9.visible = true;
    this.dtg_DetailTO0.visible = true;
    this.dtg_DetailTO1.visible = true;
    this.dtg_DetailTO2.visible = true;
    this.dtg_DetailTO3.visible = true;
    this.dtg_DetailTO4.visible = true;
    this.dtg_DetailTO5.visible = true;
    this.dtg_DetailTO6.visible = true;
    this.dtg_DetailTO7.visible = true;
    this.dtg_DetailTO8.visible = true;
    this.dtg_DetailTO9.visible = true;
    this.dtg_DetailNA0.visible = true;
    this.dtg_DetailNA1.visible = true;
    this.dtg_DetailNA2.visible = true;
    this.dtg_DetailNA3.visible = true;
    this.dtg_DetailNA4.visible = true;
    this.dtg_DetailNA5.visible = true;
    this.dtg_DetailNA6.visible = true;
    this.dtg_DetailNA7.visible = true;
    this.dtg_DetailNA8.visible = true;
    this.dtg_DetailNA9.visible = true;
    this.dtg_DetailN0.visible = true;
    this.dtg_DetailN1.visible = true;
    this.dtg_DetailN2.visible = true;
    this.dtg_DetailN3.visible = true;
    this.dtg_DetailN4.visible = true;
    this.dtg_DetailN5.visible = true;
    this.dtg_DetailN6.visible = true;
    this.dtg_DetailN7.visible = true;
    this.dtg_DetailN8.visible = true;
    this.dtg_DetailN9.visible = true;
  }

  /**
   * 会員生協別情報を非表示
   */
  public setResultDetailFalse(): void {
    this.dtg_ResultList.scrollPosition = new Point(0, 0);

    this.dtg_OrderCode.visible = true;
    this.dtg_DelivCatlogId.visible = true;
    this.dtg_MediumName.visible = true;
    this.dtg_Pcode.visible = true;
    this.dtg_HandlingCoop1.visible = true;
    this.dtg_HandlingCoop2.visible = true;
    this.dtg_HandlingCoop3.visible = true;
    this.dtg_HandlingCoop4.visible = true;
    this.dtg_HandlingCoop5.visible = true;
    this.dtg_HandlingCoop6.visible = true;
    this.dtg_HandlingCoop7.visible = true;
    this.dtg_HandlingCoop8.visible = true;
    this.dtg_ResultPriceTotal.visible = true;
    this.dtg_ResultNumTotal.visible = true;
    this.dtg_ResultPiTotal.visible = true;
    this.dtg_PlanNumTotal.visible = true;

    this.dtg_Dummy.visible = true;

    this.dtg_DetailI0.visible = false;
    this.dtg_DetailI1.visible = false;
    this.dtg_DetailI2.visible = false;
    this.dtg_DetailI3.visible = false;
    this.dtg_DetailI4.visible = false;
    this.dtg_DetailI5.visible = false;
    this.dtg_DetailI6.visible = false;
    this.dtg_DetailI7.visible = false;
    this.dtg_DetailI8.visible = false;
    this.dtg_DetailI9.visible = false;
    this.dtg_DetailT0.visible = false;
    this.dtg_DetailT1.visible = false;
    this.dtg_DetailT2.visible = false;
    this.dtg_DetailT3.visible = false;
    this.dtg_DetailT4.visible = false;
    this.dtg_DetailT5.visible = false;
    this.dtg_DetailT6.visible = false;
    this.dtg_DetailT7.visible = false;
    this.dtg_DetailT8.visible = false;
    this.dtg_DetailT9.visible = false;
    this.dtg_DetailG0.visible = false;
    this.dtg_DetailG1.visible = false;
    this.dtg_DetailG2.visible = false;
    this.dtg_DetailG3.visible = false;
    this.dtg_DetailG4.visible = false;
    this.dtg_DetailG5.visible = false;
    this.dtg_DetailG6.visible = false;
    this.dtg_DetailG7.visible = false;
    this.dtg_DetailG8.visible = false;
    this.dtg_DetailG9.visible = false;
    this.dtg_DetailC0.visible = false;
    this.dtg_DetailC1.visible = false;
    this.dtg_DetailC2.visible = false;
    this.dtg_DetailC3.visible = false;
    this.dtg_DetailC4.visible = false;
    this.dtg_DetailC5.visible = false;
    this.dtg_DetailC6.visible = false;
    this.dtg_DetailC7.visible = false;
    this.dtg_DetailC8.visible = false;
    this.dtg_DetailC9.visible = false;
    this.dtg_DetailS0.visible = false;
    this.dtg_DetailS1.visible = false;
    this.dtg_DetailS2.visible = false;
    this.dtg_DetailS3.visible = false;
    this.dtg_DetailS4.visible = false;
    this.dtg_DetailS5.visible = false;
    this.dtg_DetailS6.visible = false;
    this.dtg_DetailS7.visible = false;
    this.dtg_DetailS8.visible = false;
    this.dtg_DetailS9.visible = false;
    this.dtg_DetailTO0.visible = false;
    this.dtg_DetailTO1.visible = false;
    this.dtg_DetailTO2.visible = false;
    this.dtg_DetailTO3.visible = false;
    this.dtg_DetailTO4.visible = false;
    this.dtg_DetailTO5.visible = false;
    this.dtg_DetailTO6.visible = false;
    this.dtg_DetailTO7.visible = false;
    this.dtg_DetailTO8.visible = false;
    this.dtg_DetailTO9.visible = false;
    this.dtg_DetailNA0.visible = false;
    this.dtg_DetailNA1.visible = false;
    this.dtg_DetailNA2.visible = false;
    this.dtg_DetailNA3.visible = false;
    this.dtg_DetailNA4.visible = false;
    this.dtg_DetailNA5.visible = false;
    this.dtg_DetailNA6.visible = false;
    this.dtg_DetailNA7.visible = false;
    this.dtg_DetailNA8.visible = false;
    this.dtg_DetailNA9.visible = false;
    this.dtg_DetailN0.visible = false;
    this.dtg_DetailN1.visible = false;
    this.dtg_DetailN2.visible = false;
    this.dtg_DetailN3.visible = false;
    this.dtg_DetailN4.visible = false;
    this.dtg_DetailN5.visible = false;
    this.dtg_DetailN6.visible = false;
    this.dtg_DetailN7.visible = false;
    this.dtg_DetailN8.visible = false;
    this.dtg_DetailN9.visible = false;

    this.dtg_ResultList.refresh(true);
  }

  // 出力ボタン制御
  public updateOutputBtnEnableMode(value: boolean): void {
    this.btn_Out.nativeElement.disabled = !value;
  }

  // 実績履歴WorkTable作成完了フラグ
  public updateMakedWKTFlag(value: boolean): void {
    this.resultListVo.makedWKT = value;
  }

  // 実績履歴WorkTable作成総件数
  public updateMakedTotalCnt(value: number): void {
    this.resultListVo.totalCnt = value;
  }

  // 実績履歴WorkTable作成SessionID
  public updateSessionId(value: string): void {
    this.resultListVo.sessionId = value;
  }

  /**
   * 前へ/次へ(ボタン)の活性制御を行う
   */
  public setEnabledPrevNext(): void {
    setTimeout(() => {
      this.plessEnabledSetting();
    });
  }

  /**
   * 排他チェックOK処理
   */
  public lockOk_registPlanNum(successParam: any): void {
    // public lockOk_registPlanNum(): void {

    // 出力情報の取得要求を行う
    // 要求先：/KYMW08/registPlanNum.xml
    this.registPlanNumService.execute(successParam.kymw0800Model, successParam.registVO);
  }

  /**
   * 排他チェックError処理
   */
    public lockErr_registPlanNum(result: any): void {
    let UserName = '';
    if (result.result.obj.UnlockedInfo.Catalog[0] != null ) {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Catalog[0].UserName) + ']';
    } else if (result.result.obj.UnlockedInfo.Page[0] != null ) {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Page[0].UserName) + ']';
    } else {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.PlanGoods[0].UserName) + ']';
    }
    this.dialogService.openAlertGetMessage('E0141', [UserName]);
}

  /**
 * コンテキストメニューを追加
 */
  private setContextMenu(): void {
    this.contextMenu = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [
        { header: '計画数自動セット', caption: '計画数自動セット', cmd: 'RegistPlanNum', enabled: false },
      ],
      command: this.getFormatMenuCommand(),
      itemClicked: () => {
        switch (this.contextMenu.selectedValue) {
          case 'RegistPlanNum':
            this.eventRegistPlanNum_CLICKHandler();
            break;
        }
      }
    });

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_ResultList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenu !== undefined) {

        const ht = this.dtg_ResultList.hitTest(e.pageX, e.pageY);
        if (ht.cellType === CellType.Cell) {
          // 右クリック押下時に対象行を選択状態にする
          const grid = new CellRange(ht.row, ht.col);
          this.dtg_ResultList.select(grid, false);
          this.eventContextMenu_Handler();
          this.eventDtgResultListContextMenu_MENUSELECTHandler();
          // コンテキストメニューの活性非活性制御
          // メニュー表示
          this.contextMenu.show(e);
        } else if (ht.cellType === CellType.None) {
          this.eventContextMenu_Handler();
          this.eventDtgResultListContextMenu_MENUSELECTHandler();
          // メニュー表示
          this.contextMenu.show(e);
        }
      }
    });

    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenu.itemsSource[0], 'none');
  }

  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  public clickPdfLinkButton(data: any, dataField: string) {
    if (data[dataField] === 0) {
  return;
}

    // ファイル名を作成
    const fileName: string = data['OrderCode'] + '_' + data['MediumType'] + '_'
      + this.getCoopCode(dataField) + '_'
      + PlessViewUtilsSub.zeroPadding(3, data[dataField]) + '.pdf';

    this.eventPdfLinkButtonClickHandler(fileName);
  }

  // クリックした生協コード取得
  private getCoopCode(obj: string) {
    let coopCode: string = <string>'';

    switch (obj) {
      case 'PageNum1':
        coopCode = this.kymw00Model.COOP_CODE_IB;
        break;
      case 'PageNum2':
        coopCode = this.kymw00Model.COOP_CODE_TO;
        break;
      case 'PageNum3':
        coopCode = this.kymw00Model.COOP_CODE_GU;
        break;
      case 'PageNum4':
        coopCode = this.kymw00Model.COOP_CODE_TI;
        break;
      case 'PageNum5':
        coopCode = this.kymw00Model.COOP_CODE_SA;
        break;
      case 'PageNum6':
        coopCode = this.kymw00Model.COOP_CODE_TK;
        break;
      case 'PageNum7':
        coopCode = this.kymw00Model.COOP_CODE_NA;
        break;
      case 'PageNum8':
        coopCode = this.kymw00Model.COOP_CODE_NI;
        break;
    }

    return coopCode;
  }

  /**
   * 活性・非活性制御処理
   *
   * @memberof KYMW0800Component
   */
  plessEnabledSetting() {
    this.setListBtn();
  }
}
